import { font } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    margin-right: 10px;
    text-transform: none;
    ${font(14, '#7f7d7d')}
`;
